import(/* webpackMode: "eager" */ "/codebuild/output/src2425947283/src/apps/web/app/[locale]/error.tsx");
